import { useEffect, useState } from 'react';

import { cacheImages } from '../lib/cacheImages';

const usePreloadImages = (
  urlList?: string[] | [string, string][],
): { isLoading: boolean; isError: boolean } => {
  const [isLoading, setIsLoading] = useState(!!urlList);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (urlList) {
      cacheImages(urlList)
        .then(() => setIsLoading(false))
        .catch(() => setIsError(true));
    }
  }, [urlList]);

  return { isLoading, isError };
};

export { usePreloadImages };
